<template>
  <div>
    <b-row class="mb-3">
      <b-col lg="7">
        <div class="d-flex align-items-center mb-4">
          <LiveMonitorIcon class="mr-2" />
          <h4 class="m-0">{{ title }}</h4>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-tabs lazy>
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center">
                <LiveMonitorIcon class="mr-2" style="opacity: 0.7" />
                <span>SMS Diagnostics</span>
              </div>
            </template>
            <sms-diagnostics />
          </b-tab>
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center">
                <BestFitIcon size="20" class="mr-2" style="opacity: 0.7" />
                <span>SMS Spam report</span>
              </div>
            </template>
            <sms-spam-report />
          </b-tab>
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center">
                <ShieldIcon size="20" class="mr-2" style="opacity: 0.7" />
                <span>Whitelist</span>
              </div>
            </template>
            <sms-whitelist />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SmsDiagnostics from "./SmsDiagnostics";
import SmsSpamReport from "./SmsSpamReport";
import SmsWhitelist from "./whitelisting/SmsWhitelist";

export default {
  components: { SmsSpamReport, SmsDiagnostics, SmsWhitelist },
  props: ["title"],
};
</script>
